// extracted by mini-css-extract-plugin
export default {"btnContainer":"SubmitBtn_btnContainer__hA7Hl","btn":"SubmitBtn_btn__vMtTh"};